import { useEffect, useState } from "react";
import { SortedResultsList, useQuestionizerStore } from "../types/state.ts";
import {
  FDWAntragsteller,
  FDWResultEntry,
} from "../../../restfd2/fdw_result.ts";
import { FoerderungenByGewerkElement } from "./questionizer-result-foerderungen_by_gewerk.tsx";


export function QuestionizerResultByGewerk() {
  const include_all_results_in_print = useQuestionizerStore(
    (state) => state.config?.include_all_results_in_print || false
  );
  const include_in_print = useQuestionizerStore(
    (state) => state.include_in_print
  );
  const config = useQuestionizerStore((state) => state.config);
  const gewerk = useQuestionizerStore((state) => state.gewerk);

  const setIncludeInPrint = useQuestionizerStore(
    (state) => state.setIncludeInPrint
  );
  const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">(
    "zuschusse"
  );
  const result = useQuestionizerStore((state) => state.result);
  const initialSelectAll = include_all_results_in_print || false;
  const [select_all, setSelectAll] = useState(initialSelectAll);

  if (result == undefined && config?.layout == undefined) {
    return <div></div>;
  }

  const result_by_gewerk : Record<string, Array<FDWResultEntry>> = {};
  for (const entry of result) {
    for (const gewerk of entry.gewerke_id.split(",")) {
      if(!result_by_gewerk[gewerk.trim()]){
        result_by_gewerk[gewerk.trim()] = [];
      }
      result_by_gewerk[gewerk.trim()].push(entry);
    }
  }

  const toggle = config?.layout
    .flatMap((page) =>
      page.sections.flatMap((section) =>
        section.inputs.flatMap((input) => input)
      )
    )
    .filter((input) => input.type == "gewerk" && input.code && gewerk[input.id]);

  const result_by_toggle_label = toggle?.reduce((acc, t) => {
    if (!acc[t.label]) {
      acc[t.label] = [];
    }
    Object.keys(t.code).forEach((c) => {
      const result_entries = result_by_gewerk[c];
      if(!result_entries){return}
      result_entries.forEach((result_entry)=>{
        if(acc[t.label].find((e)=>e.fp_id == result_entry.fp_id)){return}
        acc[t.label].push(
          {...result_entry, print: include_in_print[result_entry.fp_id]}
        )
      });
    });
    return acc;
  }, {});

  return <div className="space-y-2">
    {Object.keys(result_by_toggle_label).map((key) => {
      const sortedData = [...result_by_toggle_label[key]].sort(
        (a, b) => Number(a.fp_id) - Number(b.fp_id)
      );

      if(sortedData.length == 0 || key == ""){
        return <></>
      }

      const zuschuesse = sortedData
        .filter((entry) => entry.fp_type == "Zuschuss")
        .reduce((acc: SortedResultsList, entry: FDWResultEntry) => {
          if (!acc[entry.region]) {
            acc[entry.region] = { region: entry.region, list: [entry] };
          } else {
            acc[entry.region].list.push(entry);
          }
          return acc;
        }, {});

      const darlehen = sortedData
        .filter((entry) => entry.fp_type == "Darlehen")
        .reduce((acc: SortedResultsList, entry: FDWResultEntry) => {
          if (!acc[entry.region]) {
            acc[entry.region] = { region: entry.region, list: [entry] };
          } else {
            acc[entry.region].list.push(entry);
          }
          return acc;
        }, {});

      let zuschuesse_length = Object.keys(zuschuesse).flatMap(
        (key) => zuschuesse[key].list
      ).length;
      let darlehen_length = Object.keys(darlehen).flatMap(
        (key) => darlehen[key].list
      ).length;

       let zuschuesse_selected = Object.keys(zuschuesse).flatMap(
        (key) => zuschuesse[key].list
      ).filter((z) => z.print).length;
      let darlehen_selected= Object.keys(darlehen).flatMap(
        (key) => darlehen[key].list
      ).filter((z) => z.print).length;

      return <>
        <FoerderungenByGewerkElement key={key} zuschuesse={zuschuesse} darlehen={darlehen} label={key} darlehen_length={darlehen_length} zuschuesse_length={zuschuesse_length} selected_count={zuschuesse_selected + darlehen_selected}/>
      </>
  })}
  </div>;
}